var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10af9f28"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "question_form"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", null, "相談入力確認", -1));
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "対象となるメンターの職種", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "相談タイプ", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "件名", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "must max" }, "内容", -1));
const _hoisted_10 = { class: "dd_max" };
const _hoisted_11 = { style: { "white-space": "pre-line" } };
const _hoisted_12 = /*#__PURE__*/ _createStaticVNode("<details class=\"hint_box\" data-v-10af9f28><summary data-v-10af9f28>※書き方のヒント</summary><div class=\"inner\" data-v-10af9f28><div class=\"hint\" data-v-10af9f28><p data-v-10af9f28>全般</p><ul class=\"ul_1\" data-v-10af9f28><li data-v-10af9f28> ・相談の要点は、1つに絞りましょう。<br data-v-10af9f28> 相談がいくつもあると、結局何を一番聞きたいのかが伝わりにくくなります。<br data-v-10af9f28> 相談内容を絞り込む作業が必要です。 </li><li data-v-10af9f28> ・投稿する前に、他の人に意味が伝わるか、今いちど読み返して、校正しましょう。<br data-v-10af9f28><ul class=\"ul_num\" data-v-10af9f28><li data-v-10af9f28> ① 意図を伝えるのに必要な情報をすべて盛り込んでいますか？ </li><li data-v-10af9f28> ② 余分なことを書いてませんか？削れる箇所はないですか？ </li><li data-v-10af9f28> ③ できるだけ事実データを用いた客観的な説明となっていますか？ </li><li data-v-10af9f28>④ 論理的／構造的／具体的にまとめられていますか？</li></ul></li></ul></div><div class=\"hint\" data-v-10af9f28><p data-v-10af9f28>【現状・背景】</p> 次の観点から事実データを元に記述しましょう。<br data-v-10af9f28> 背景から詳しく説明することで、本質的な課題・解決を見つけることに繋がります。<br data-v-10af9f28><ul class=\"ul_num\" data-v-10af9f28><li data-v-10af9f28>① 会社の概要</li><li data-v-10af9f28>② 現在の状況と問題、これまでの取組み</li><li data-v-10af9f28> ③ 実現したいこと（短期/中期/長期目標、納期、予算、その理由） </li></ul><p data-v-10af9f28>【相談内容】</p> 次の観点から具体的に記述しましょう。<br data-v-10af9f28><ul class=\"ul_num\" data-v-10af9f28><li data-v-10af9f28> ① 相談内容（課題・解決）<br data-v-10af9f28> さまざまな問題の中で、何を課題・解決したいのか明確にしましょう。その理由も。 </li><li data-v-10af9f28> ② 自分がどこまで理解しているか<br data-v-10af9f28> どこまで理解できているかによって、回答の仕方や内容も変わってきます。 </li><li data-v-10af9f28> ③ その他補足<br data-v-10af9f28> 制限事項、懸念事項、メンターに知っておいて欲しいことを記述しましょう。 </li></ul></div></div></details>", 1);
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "期限", -1));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "err" }, "※登録後はキャンセルできませんので、十分ご確認下さい。", -1));
const _hoisted_15 = {
    key: 0,
    style: { "color": "red", "font-size": "19px" }
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_18 = { class: "bt_box" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    class: "modal_win",
    "data-target": "additional-confirm-modal"
}, "登録", -1));
const _hoisted_21 = {
    id: "additional-confirm-modal",
    class: "modal js-modal"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "modal-bg" }, null, -1));
const _hoisted_23 = { class: "modal-content" };
const _hoisted_24 = { class: "close_bt bt_modal_close" };
const _hoisted_25 = {
    key: 0,
    class: "pop"
};
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "bt_modal_close bt_clear"
    }, "キャンセル")
], -1));
const _hoisted_28 = {
    key: 1,
    class: "pop"
};
const _hoisted_29 = { class: "spinner-container" };
const _hoisted_30 = { class: "spinner" };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "message-box" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createElementVNode("strong", null, "現在決済処理中です")
    ]),
    /*#__PURE__*/ _createElementVNode("p", null, "ボタンを押したり移動したりせず、このまましばらくお待ちください。処理が完了したら自動的に画面が変わります。")
], -1));
import { ref, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import { Inertia } from '@inertiajs/inertia';
import { QuestionType } from '@util/Consts';
import ImageFrame from '@component/ImageFrame.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'question_check',
    props: {
        common: null,
        form: null,
        additional_question_amount: null
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const form = InertiaUtil.getForm({
            job_group_id: (_a = props.form.job_group_id) !== null && _a !== void 0 ? _a : '',
            job_id: props.form.job_id,
            other_job_name: (_b = props.form.other_job_name) !== null && _b !== void 0 ? _b : '',
            question_type_id: props.form.question_type_id,
            subject: props.form.subject,
            content: props.form.content,
            deadline: props.form.deadline,
        });
        const jobOptions = ref([]);
        const typeOptions = ref([]);
        const showLoading = ref(false);
        const formatJobName = computed(() => {
            const result = Formatter.formatJob(form.job_group_id, form.job_id, form.other_job_name, jobOptions.value);
            return result;
        });
        const formatTypeName = computed(() => {
            var _a, _b;
            const type = (_a = typeOptions.value.find(value => value.id === form.question_type_id)) !== null && _a !== void 0 ? _a : null;
            return (_b = type === null || type === void 0 ? void 0 : type.name) !== null && _b !== void 0 ? _b : '';
        });
        const onClickReturn = () => {
            Inertia.get(route('question.create'));
        };
        const onClickToPaymentRegister = () => {
            Inertia.get(route('payment.show'));
        };
        let sendProcessing = false;
        const onSend = () => {
            var _a, _b;
            const param = {
                job_group_id: (_a = form.job_group_id) !== null && _a !== void 0 ? _a : '',
                job_id: form.job_id,
                other_job_name: (_b = form.other_job_name) !== null && _b !== void 0 ? _b : '',
                question_type_id: form.question_type_id,
                subject: form.subject,
                content: form.content,
                deadline: form.deadline,
            };
            if (sendProcessing)
                return;
            sendProcessing = true;
            showLoading.value = true;
            axios.post(route('question.store'), param).then(response => {
                var _a, _b, _c, _d;
                if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payment_confirm_url) {
                    window.location.href = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.payment_confirm_url;
                }
                else if ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) {
                    Alert.Error((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message);
                    showLoading.value = false;
                    window.location.reload();
                }
                else {
                    sessionStorage.removeItem('oldQuestionForm');
                    Inertia.get(route('question.index', { option_type: QuestionType.MY_POSTS }));
                }
                sendProcessing = false;
                setTimeout(() => {
                    showLoading.value = false;
                }, 5000);
            });
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const [jobs, types] = yield Promise.all([
                axios
                    .get('jobs')
                    .then(res => res.data)
                    .catch(e => []),
                axios
                    .get('question-types')
                    .then(res => res.data)
                    .catch(e => []),
            ]);
            jobOptions.value = jobs;
            typeOptions.value = types;
        }));
        onMounted(() => {
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("form", null, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_6,
                                        _createElementVNode("dd", null, _toDisplayString(_unref(formatJobName)), 1),
                                        _hoisted_7,
                                        _createElementVNode("dd", null, _toDisplayString(_unref(formatTypeName)), 1),
                                        _hoisted_8,
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).subject), 1),
                                        _hoisted_9,
                                        _createElementVNode("dd", _hoisted_10, [
                                            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(form).content), 1),
                                            _hoisted_12
                                        ]),
                                        _hoisted_13,
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).deadline), 1)
                                    ]),
                                    _hoisted_14,
                                    (props.additional_question_amount)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                            _hoisted_16,
                                            _createTextVNode("カード会社が提供する 本人認証画面 が表示される場合があります。"),
                                            _hoisted_17,
                                            _createTextVNode(" 本人認証画面 が表示された場合には本人認証を完了してください。 ")
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    onClick: onClickReturn,
                                                    class: "bt_back"
                                                }, " 戻る ")
                                            ]),
                                            _createElementVNode("li", null, [
                                                (!props.additional_question_amount)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        id: "submit-button",
                                                        onClick: _withModifiers(onSend, ["prevent"])
                                                    }, "登録", 8, _hoisted_19))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _hoisted_20,
                                                        _createElementVNode("div", _hoisted_21, [
                                                            _hoisted_22,
                                                            _createElementVNode("div", _hoisted_23, [
                                                                _createElementVNode("div", _hoisted_24, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                                                ]),
                                                                (!showLoading.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                                        _createElementVNode("h2", null, [
                                                                            _createTextVNode(" 追加相談のため " + _toDisplayString(props.additional_question_amount.toLocaleString()) + "円/件(税込) 発生します。", 1),
                                                                            _hoisted_26,
                                                                            _createTextVNode(" 登録してよろしいですか？ ")
                                                                        ]),
                                                                        _createElementVNode("div", { class: "bt_box clear" }, [
                                                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                                                _hoisted_27,
                                                                                _createElementVNode("li", null, [
                                                                                    _createElementVNode("button", {
                                                                                        type: "button",
                                                                                        class: "bt_modal_close bt_ok",
                                                                                        onClick: onSend
                                                                                    }, "OK")
                                                                                ])
                                                                            ])
                                                                        ])
                                                                    ]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                                        _createElementVNode("div", _hoisted_29, [
                                                                            _createElementVNode("div", _hoisted_30, [
                                                                                _createVNode(ImageFrame, { src: "images/index/loading.gif" })
                                                                            ]),
                                                                            _hoisted_31
                                                                        ])
                                                                    ]))
                                                            ])
                                                        ])
                                                    ], 64))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
